import { formatCurrency } from '@brazilian-utils/brazilian-utils';
import {all, takeEvery, put, call, takeLatest} from 'redux-saga/effects';
import {
  changeBalance,
  changeBalanceLoading,
  changeEntriesData,
  appendEntriesData,
  changeLoading,
  changeLoadingMore,
  changeWithdrawLoading,
  changeAutoWithdrawStatus,
  FinancesActionTypes,
  AutoWithdrawStatus,
  asyncAutoWithdrawStatus,
  asyncBalance,
} from 'store/reducers/finances.reducer';
import handleError from 'utils/handleError';
import Notification from 'utils/notifications';
import { getEntries, requestAllWithdraw, getBalance, getAutoWithdrawStatus } from 'utils/web-api';

const DEFAULT_PAGE_SIZE = 50;

function* entriesData({payload = {}}) {
  const {page = 1, pageSize = DEFAULT_PAGE_SIZE, append = false} = payload || {};
  try {
    if (append) {
      yield put(changeLoadingMore(true));
    } else {
      yield put(changeLoading(true));
    }
    const response = yield call(getEntries, {page, page_size: pageSize});
    if (append) {
      yield put(appendEntriesData(response));
    } else {
      yield put(changeEntriesData(response));
    }
  } catch (error) {
    handleError(error);
  } finally {
    if (append) {
      yield put(changeLoadingMore(false));
    } else {
      yield put(changeLoading(false));
    }
  }
}

function* balance({payload}) {
  try {
    yield put(changeBalanceLoading(true));
    const response = yield call(getBalance, payload);
    yield put(changeBalance(response));
  } catch (error) {
    handleError(error);
  } finally {
    yield put(changeBalanceLoading(false));
  }
}

function* allWithdraw() {
  try {
    yield put(changeWithdrawLoading(true));
    const response = yield call(requestAllWithdraw);
    yield put(asyncBalance());
    Notification('success', `Um saque de R$ ${formatCurrency(response.amount / 100)} foi solicitado!`);
  } catch (error) {
    const status = error.response?.status;
    if (status === 455) {
        Notification('error', 'Saldo insuficiente para saque.');
    } else if (status === 403) {
        // O saque deste seller passou a ser automático (habilitado depois que a tela
        // carregou): recarrega o status para trocar o botão pelo aviso.
        Notification('warning', 'O saque da sua conta é feito automaticamente todo dia útil, por volta das 15h (horário de Brasília).');
        yield put(asyncAutoWithdrawStatus());
    } else {
        Notification('error', 'Erro ao realizar a solicitação de saque, tente novamente em instantes.');
    }
  } finally {
    yield put(changeWithdrawLoading(false));
  }
}

// Sem toast no erro: 'error' mostra o botão manual, e o backend continua recusando com 403
// se o seller estiver no automático. Uma falha aqui nunca tira o saque do seller.
function* autoWithdrawStatus() {
  try {
    yield put(changeAutoWithdrawStatus(AutoWithdrawStatus.LOADING));
    const response = yield call(getAutoWithdrawStatus);
    yield put(changeAutoWithdrawStatus(
      response?.automatic === true ? AutoWithdrawStatus.AUTOMATIC : AutoWithdrawStatus.MANUAL,
    ));
  } catch (error) {
    console.error('Falha ao consultar o status do saque automático', error);
    yield put(changeAutoWithdrawStatus(AutoWithdrawStatus.ERROR));
  }
}

export default function* MySaga() {
  yield all([
    yield takeEvery(FinancesActionTypes.ASYNC_ENTRIES_DATA, entriesData),
    yield takeEvery(FinancesActionTypes.ASYNC_BALANCE, balance),
    yield takeLatest(FinancesActionTypes.ASYNC_ALL_WITHDRAW, allWithdraw),
    // takeLatest: uma consulta nova (ex.: após o 403 do saque) descarta a anterior.
    yield takeLatest(FinancesActionTypes.ASYNC_AUTO_WITHDRAW_STATUS, autoWithdrawStatus),
  ]);
}
